import PresentationBlock from '@/components/bodyBlocks/presentationBlock/presentationBlock'
import '../../index.css'

function SobreNosotros() {
  return (
    <div>
        <PresentationBlock/>
    </div>
   
  )
}

export default SobreNosotros
